import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { dashboardRoute } from '@app-constants/app.constants';
import { LoginService } from '@app-services/login/login.service';
import { filter } from 'rxjs/operators';
import { navigateBetweenProjects } from 'src/app/helpers/functions';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private history: any = [];
  public previousUrl: any = null;
  public currentUrl: any = null;
  constructor(
    private router: Router,
    private location: Location,
    private loginService: LoginService
  ) {
    if (environment.production) {
      window.console.group = function () { };
      window.console.groupEnd = function () { };
      window.console.log = function () { };
      window.console.error = function () { };
      window.console.info = function () { };
      window.console.warn = function () { };
    }
    this.router.events.pipe(
      filter((event:any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  setLocationHistory = (_url: string = '') => {
    // _url = _url.split('?')[0]
    if (
      this.history.length == 0 ||
      (this.history.length > 0 &&
        this.history[this.history.length - 1] !== _url &&
        !_url.split('/').includes('waiting-class') &&
        !_url.split('/').includes('student-live-class') &&
        !_url.split('/').includes('teacher-live-class') &&
        !_url.split('/').includes('end-class')
      )
    ) {
      window.scrollTo(0, 0)
      this.history.push(_url);
      // this.history = (Array.isArray(this.history) ? this.history : this.history.split(''))
      // .filter((c, i) => c !== this.history[i + 1]);
    }
  }

  back(): void {
    this.history.pop();
    
    if (this.history.length > 0) {
      this.location.back();
      window.scrollTo(0, 0);
    } else {
      const route = `${dashboardRoute}/${
        localStorage.getItem('SelectedTab') || 'assessment'
      }`;
      navigateBetweenProjects(this.router, route);
    }
  }

  getLocationHistory = (_url: string = '') => {
    if (
      this.history.length == 0 ||
      (this.history.length > 0 &&
        !_url.split('/').includes('waiting-class') &&
        !_url.split('/').includes('student-live-class') &&
        !_url.split('/').includes('teacher-live-class') &&
        !_url.split('/').includes('end-class')
      )
    ) {
      window.scrollTo(0, 0)

      let previousUrl = this.history.slice(-2,-1)      
      localStorage.setItem('previousUrl',previousUrl)
      return previousUrl
    }
  }

}
